/** When your routing table is too long, you can split it into small modules */

const authRouter = [
  {
    path: "forgotPassword",
    name: "ForgotPassword",
    component: () => import("@/views/auth/pages/ForgotPassword")
  },
  {
    path: "hasSendPassword",
    name: "HasSendPassword",
    component: () => import("@/views/auth/pages/HasSendPassword")
  },
  {
    path: "hasSendEmail",
    name: "HasSendEmail",
    component: () => import("@/views/auth/pages/HasSendEmail")
  },
  {
    // 信箱點擊連結
    // 跳轉重設密碼
    path: "resetPassword",
    name: "resetPassword",
    component: () => import("@/views/auth/pages/ResetPassword")
  },
  {
    // 信箱點擊連結
    // 驗證信箱 之後跳轉至成功或失敗(逾期)
    path: "validationEmail",
    name: "ValidationEmail",
    component: () => import("@/views/auth/pages/ValidationEmail")
  },
  {
    path: "register",
    name: "register",
    component: () => import("@/views/auth/register/Register")
  },
  {
    path: "registerSteps",
    name: "registerSteps",
    component: () => import("@/views/auth/register/RegisterSteps")
  },
  {
    path: "member",
    name: "Member",
    component: () => import("@/views/auth/pages/Member")
  },
  {
    path: "orderList",
    name: "OrderList",
    component: () => import("@/views/auth/pages/OrderList")
  },
  {
    path: "refund/:orderNum",
    name: "OrderRefund",
    meta: {
      order: true
    },
    component: () => import("@/views/auth/pages/OrderRefund")
  },
  {
    path: "ordered/:orderNum/payment",
    name: "OrderedPayment",
    meta: {
      order: true
    },
    component: () => import("@/views/auth/pages/OrderedPayment")
  },
  {
    path: "ordered/:orderId/complete",
    name: "OrderedComplete",
    meta: {
      order: true
    },
    component: () => import("@/views/auth/pages/OrderedComplete")
  },
  {
    path: "ticket",
    name: "Ticket",
    props: true,
    component: () => import("@/views/auth/pages/Ticket")
  },
  {
    path: "ticket/:tab",
    name: "TicketTab",
    props: true,
    component: () => import("@/views/auth/pages/Ticket")
  },
  {
    path: "userInfo/:urlTabSelect?",
    name: "UserInfo",
    props: true,
    component: () => import("@/views/auth/pages/UserInfo")
  },
  {
    path: "changeEmail",
    name: "ChangeEmail",
    component: () => import("@/views/auth/pages/ChangeEmail")
  },
  {
    path: "terms",
    name: "Terms",
    component: () => import("@/views/auth/pages/Terms")
  },
  {
    path: "contactus",
    name: "Contactus",
    component: () => import("@/views/auth/pages/Contact")
  },
  {
    path: "faq",
    name: "FAQ",
    component: () => import("@/views/pages/FAQ")
  },
  {
    path: "logout",
    name: "Logout",
    component: () => import("@/views/auth/Logout")
  }
];

export default authRouter;
